module.exports = __webpack_public_path__ + "static/assets/943a08c7737f3b3bd4ab10f0f6a1c463.png";